import { Case } from '../../types/content';

/**
 * "문제에서 시작한 일곱 이야기" (A~E 데이터 플랫폼, F~G 백엔드 토대). 카드 제목에 숫자 금지, 숫자는 evidence(각주)에만.
 * 사내 시스템명·테이블명·동료 이름·부서 실명·비즈니스 수치는 쓰지 않는다. 서술 문장은 합쇼체.
 * diagram 은 역할 구조만 그린다(시스템명 없음).
 */
export const cases: Case[] = [
  {
    id: 'A',
    competency: '재사용 가능한 데이터 프로덕트',
    title: '사용자 한 명 한 명을 세 축으로 정의하다',
    problem:
      '사용자별 타겟팅에 대한 틀이 없었습니다. 요청이 오면 데이터 분석팀이 그때그때 추출로만 대응했고, 같은 질문이 다른 조직에서 다른 정의로 다시 왔습니다.',
    approach:
      'RFM 기반 세분화로 사용자 한 명 한 명을 최근성·빈도·금액 세 축으로 정의하고, 이 기준을 주기적으로 갱신하는 데이터 모델(l2/l4)을 만들었습니다. 정의된 세그먼트를 화면에서 조건을 바꿔 볼 수 있게 비동기 조회와 연결하고, 그 결과를 푸시 타겟팅으로 이어지게 했습니다.',
    change:
      '타겟팅이 "추출 요청"에서 "같은 기준으로 고르는 일"이 됐습니다. 처음 공유한 조직보다 다른 조직들이 먼저 자발적으로 쓰기 시작했고, 세그먼트별 전환 격차가 푸시 우선순위의 근거로 쓰였습니다.',
    stack: ['Redshift', 'Athena', 'Airflow', 'Kotlin', 'React'],
    evidence: '여러 조직으로 확산 (2025 하반기)',
    period: '2025.07 – 2025.12',
    chapter: 'data',
    myPart: '세 축 정의와 갱신 데이터 모델(l2/l4) 설계, 비동기 조회 흐름 구현, 화면 PoC',
    teamPart: '화면 정식 구현과 푸시 연동은 팀과 함께'
  },
  {
    id: 'B',
    competency: '문제 본질 정의 → 구조 재설계 · 현업 협업',
    title: '조회 도구를 의사결정 플랫폼으로 다시 정의하다',
    problem:
      '기능 요청이 쌓이는 대시보드였습니다. 요청대로 만들수록 화면은 늘었지만 현업의 판단은 빨라지지 않았고, 데이터 팀은 "요청 처리 조직"이 되어 가고 있었습니다.',
    approach:
      '요청 처리를 멈추고 현업 인터뷰와 본사 출장으로 대표·기획·콘텐츠·광고 조직과 직접 만나 "반복되는 의사결정"의 구조를 먼저 파악했습니다. 요구사항을 분석해 그 구조에 맞는 데이터 스키마를 설계·구현하고, 메인·KPI·이벤트·작품 분석 화면을 재배치했습니다.',
    change:
      '조회 도구가 "데이터를 보고 바로 판단하는" 플랫폼으로 바뀌었습니다. 활성 사용자층이 특정 팀에서 여러 조직으로 넓어졌고, 기획 조직이 효과 분석 화면을 기준으로 실험을 설계하는 관계가 됐습니다.',
    stack: ['Kotlin', 'PostgreSQL', 'Redshift', 'React'],
    evidence: '활성 사용자 2~3배 (2026 상반기) · 반기 30여 건 현업 인터뷰 · 올해 본사 출장 3회',
    period: '2026.01 – 현재',
    chapter: 'data',
    myPart: '요구사항 분석, 데이터 스키마 설계·구현, 현업 인터뷰와 출장',
    teamPart: '권한·캐시·ETag 등 API 안정화와 화면 재배치는 팀과 함께'
  },
  {
    id: 'C',
    competency: 'AI로 달라진 업무 · 분석 보고서를 판단 도구로',
    title: 'AI 분석 보고서가 현업의 판단 도구가 되다',
    problem:
      '지표는 화면에 있었지만 해석은 사람 몫이었습니다. 작품 하나, 출판사 하나의 상황을 회사 KPI와 연결해 읽어 주는 일은 매번 분석가의 손을 거쳐야 했습니다.',
    approach:
      '작품·출판사·회사 KPI를 데이터 맵의 맥락(지표 정의·계보·해석 규칙)과 결합해 AI가 읽고 쓰게 하는 하네스를 만들었습니다. 준비 → 병렬 조회 → 맥락 결합 → 통합 LLM 분석 → 전략 플레이북 → 번역·저장·대시보드의 다섯 task로 구성하고, 각 task 아래에 조회·가공·프롬프트·검산 함수 모듈을 두었습니다. LLM 출력은 리뷰어가 산술과 금지 표현을 검산해 한 번 재시도하고, 모델은 역할별로 나눠 폴백을 둡니다. 주간 배치와 온디맨드 요청 두 경로로 돌아가며, 결과는 사내 시각화 플랫폼의 AI 인사이트 메뉴로 제공됩니다. 설계부터 구현·운영까지 혼자 맡았고, 재미가 있어 6개월 동안 주말과 틈새 시간을 들여 꾸준히 개량했습니다.',
    change:
      '사업·콘텐츠·IP·기획 등 여러 조직에서 반응이 왔고, 사업 조직의 실무자가 운영에 참고하고 싶다며 AI 인사이트 메뉴 권한을 요청해 왔습니다. 의사결정권자가 반복해서 묻는 질문을 분석 주제로 정의해 검증을 마쳤고, 알림·가드 같은 운영 기능으로 옮기는 협의가 진행 중입니다.',
    stack: ['Airflow', 'Gemini API', 'Claude', 'Redshift', 'Athena', 'S3', 'Kafka'],
    evidence: '여러 조직에서 권한 요청 (2026) · 6개월 개량',
    period: '2026.01 – 현재',
    chapter: 'data',
    myPart: '전부 직접. 설계·구현·운영·개량까지 한 사람이 맡았습니다',
    diagram: `flowchart LR
  T[트리거<br/>주간 배치 · 온디맨드 요청] --> P[prepare<br/>검증 · 날짜 · 캐시 확인]
  P --> F[fetch 병렬<br/>DW · 스냅샷 · 추천 데이터]
  F --> B[맥락 결합<br/>지표 정의 · 용어 · 이전 보고서]
  B --> L1[통합 LLM 분석<br/>리뷰어 검산 · 재시도 1회]
  L1 --> L2[전략 플레이북 LLM<br/>리뷰]
  L2 --> TR[번역 KO → JA]
  L2 --> S[(저장<br/>보고서 JSON · 캐시)]
  TR --> S
  L2 --> H[주간 HTML 대시보드]
  S --> V[사내 시각화 플랫폼<br/>AI 인사이트 메뉴]
  H --> V`
  },
  {
    id: 'D',
    competency: '여러 스택을 넘나드는 팀 만들기',
    title: '프론트·API·AI·파이프라인 네 영역을 한 팀이',
    problem:
      '네 명이 안 되는 인원으로 프론트·API·AI·데이터 파이프라인 네 영역의 운영 범위를 유지해야 했습니다. 각자 한 영역만 지키는 구조에서는 담당자 한 명의 공백이 곧 장애였습니다.',
    approach:
      '영역을 나눠 지키는 대신 넘나들자고 제안했습니다. 프론트엔드 코어 엔지니어에게는 백엔드와 데이터까지, 백엔드 코어 엔지니어에게는 프론트엔드까지, LLM 도구로 경계가 낮아진 시대의 흐름에 맞춰 함께 변하자고 설득했고 동의를 얻어 같이 했습니다. 영역별 문서화와 크로스 커버가 이 전환을 받쳤습니다.',
    change:
      '적은 인원으로도 네 영역의 운영 범위를 줄이지 않고 유지했고, 한 사람의 공백이 장애로 이어지지 않는 구조가 됐습니다. 새 합류자는 문서로 온보딩했습니다.',
    stack: ['Kotlin', 'Java', 'Python', 'TypeScript', 'AWS'],
    evidence: '운영 범위 유지',
    period: '2025.10 – 현재',
    chapter: 'data',
    myPart: '방향 제안과 설득, 영역별 문서화',
    teamPart: '두 코어 엔지니어가 각자 반대편 영역까지 넓혀 함께 운영'
  },
  {
    id: 'E',
    competency: 'DW 데이터 맵 · AI 보조 · 거버넌스',
    title: 'DW 데이터 맵, 누가 만들었는지 몰라도 쓸 수 있는 DW',
    problem:
      '지표는 이름이 같아도 정의가 달랐고, 어떤 테이블이 어디서 와서 어디로 가는지는 만든 사람만 알았습니다.',
    approach:
      'DW 데이터 맵을 만들었습니다. 테이블·컬럼·지표·용어·화면·API를 한 그래프로 잇고, 어디서 와서 어디로 가는지(계보)와 무엇을 뜻하는지(정의·해석 규칙)를 함께 담았습니다. 소스는 DW 스키마, 용어집과 코드 사전, 검수된 관계, 코드 정적 파싱, 쿼리 로그이고, 매주 자동으로 다시 컴파일해 의존성 없는 HTML 한 장으로 배포합니다. LLM이 설명 초안을 쓰되 검수된 것과 추정을 구분하고, 자동 추출은 사람이 검수한 뒤에만 정식 그래프에 넣습니다. 그래프 DB나 검색(RAG) 대신 JSON 계약과 LLM 컨텍스트 팩을 택해 구조를 단순하게 지켰습니다.',
    change:
      '"이 지표 어디 있어요?", "이 테이블 어디서 오나요?"가 검색 한 번이 됐습니다. 같은 데이터 맵이 AI 분석 보고서의 맥락과 팀의 LLM 질의 컨텍스트로도 쓰입니다.',
    stack: ['Python', 'Airflow', 'S3 → GCS', 'BigQuery', 'LLM', '정적 컴파일'],
    evidence: '노드 수백 · 관계 천 단위, 주간 갱신 · 평가에서 컨텍스트 팩이 검색(RAG)보다 정답률 우위, 환각 0',
    period: '2026.07 – 현재',
    chapter: 'data',
    myPart: '추출기·컴파일·데이터 맵 화면 설계와 구현(AI와 협업), 평가 하네스',
    teamPart: '관계 검수는 팀과 현업 스튜어드',
    diagram: `flowchart LR
  subgraph SRC[소스]
    S1[DW 스키마]
    S2[용어집 · 코드 사전]
    S3[검수된 관계]
    S4[코드 정적 파싱<br/>화면 → API → 테이블]
    S5[쿼리 로그<br/>실제 조인]
  end
  SRC --> C[매주 컴파일<br/>무결성 검증 · 추정은 draft 격리]
  C --> MAP[DW 데이터 맵<br/>그래프 + 정의 · 해석 규칙]
  MAP --> W[웹 데이터 맵<br/>정적 HTML 한 장]
  MAP --> AI[AI 분석 보고서의 맥락]
  MAP --> Q[팀 LLM 질의<br/>컨텍스트 팩]`
  },
  {
    id: 'F',
    competency: '사내 도구 구축 · 레거시 재설계',
    title: '그룹웨어를 새 구조로 다시 세우다',
    problem:
      '그룹 통합 사내 시스템은 오래된 게시판 엔진과 닷넷 서비스가 섞여 있어, 기능 하나를 고치려면 여러 스택을 동시에 건드려야 했습니다. 채용 인성검사처럼 새로 필요한 시스템은 그 위에 얹을 자리가 없었습니다.',
    approach:
      '웹오피스 포털을 게시판 엔진에서 Java 기반 모놀리식 구조로 재설계하고 DB를 정규화했습니다. 사원검색 서비스는 닷넷에서 Java로 다시 만들었고, 채용 인성검사 시스템은 신규로 구축해 안정화까지 맡았습니다. 스택을 하나로 모으는 것을 우선 결정으로 두고, 경계가 분명한 서비스부터 순서대로 옮겼습니다. 요청이 올 때마다 인프라와 DB를 새로 세우는 대신, 하나의 모놀리식 안에서 같은 도메인의 화면·API·DB 스키마·어드민을 권한별로 나눠 운영했습니다. 다른 팀이 맡기 싫어하는 일도 받아 처리해야 하는 그룹웨어 팀이 선순환할 수 있게 하려는 재설계였습니다.',
    change:
      '운영과 인수인계가 한 스택으로 단순해졌습니다. 예외를 하나 허용하면 운영 방식이 둘이 된다는 것을 이때 배웠고, 지금 데이터 파이프라인 재설계에서 테이블마다 다른 스크립트를 두지 않고 공통 계약 하나로 통일하려는 이유가 여기에 있습니다.',
    stack: ['Java', 'JavaScript', 'Oracle', 'MSSQL'],
    evidence: '리빌딩 2건 · 신규 구축 1건 (2018.11 – 2021.09)',
    period: '2018.11 – 2021.09',
    chapter: 'backend',
    myPart: '재설계 주도와 설계',
    teamPart: '구현은 팀 내 프론트엔드·백엔드 개발자와 함께'
  },
  {
    id: 'G',
    competency: '운영 파이프라인 · 외부 시스템 연동 · 플랫폼 전반',
    title: '쿠폰 발송을 상태 기반 파이프라인으로',
    problem:
      '모바일 쿠폰은 결제 직후 SMS·이메일로 도착해야 하고, 매장 POS에서 교환·반품이 실시간으로 인증돼야 합니다. 발송 실패와 재시도, 제휴사별로 다른 규격이 운영 부담의 대부분이었습니다.',
    approach:
      '발송 상태를 DB에 두고 상태 전이를 기준으로 처리하는 큐 방식으로 SMS·이메일 발송을 자동화했습니다. 상태를 DB에 둔 것은 실패 지점을 조회 한 번으로 찾고 그 지점부터 재처리하기 위해서였습니다. 실패 원인의 상당수가 외부 연동사 이슈여서 예약 발송 실패를 개발자가 매번 처리하는 것은 낭비라고 판단했고, 어드민에 발송 실패 관리 화면을 두어 실무자가 직접 재발송할 수 있게 했습니다. POS 교환·반품 인증은 Netty 기반으로 설계·구축했고, 외부 제휴사의 쿠폰 발행·통합 교환 API를 개발했습니다.',
    change:
      '발송과 재처리가 개발자 손을 떠나, 실무자가 어드민에서 상태를 보고 다시 보내는 일이 됐습니다. 5년 넘게 IDC 환경에서 서버·DB·배치·외부 연동까지 플랫폼 전반을 백엔드 엔지니어로 직접 다룬 이 시간이, 이후 데이터 플랫폼으로 옮겨 가는 여정의 토대가 됐습니다.',
    stack: ['Java', 'MySQL', 'Redis', 'Netty', 'Linux', 'IDC'],
    evidence: '발송 파이프라인 · POS 연동 · 제휴 API (2013 – 2018)',
    period: '2013.04 – 2018.10',
    chapter: 'backend',
    myPart: '발송 파이프라인, POS 인증 모듈, 제휴 API 구현',
    teamPart: '쇼핑몰 프론트와 차세대 고도화는 팀 프로젝트로 참여'
  }
];
